import { MAIN_SITE_URL } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20elegant%20workspace%20with%20a%20laptop%20displaying%20organized%20product%20spreadsheet%20grid%20on%20screen%2C%20surrounded%20by%20carefully%20curated%20fashion%20items%20like%20sneakers%20a%20leather%20bag%20and%20accessories%20on%20a%20warm%20cream%20desk%20surface%2C%20soft%20natural%20daylight%20streaming%20through%20large%20windows%20creating%20gentle%20highlights%2C%20sophisticated%20editorial%20product%20photography%20with%20organic%20composition%20and%20warm%20amber%20tones%2C%20high%20detail%20architectural%20interior%20with%20plants%20and%20refined%20minimalist%20aesthetic&width=1600&height=900&seq=hero-vigorbuy-v2&orientation=landscape"
          alt="VigorBuy Spreadsheet organized product workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-20 md:py-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-xs md:text-sm text-white font-medium">Updated 2026 Product Database</span>
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6">
            The Ultimate <strong className="font-heading font-normal text-primary-300">VigorBuy Spreadsheet</strong> &amp; Kakobuy Spreadsheet Resource Center
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
            Explore organized spreadsheets, verified product collections, QC photos, price comparisons and expert shopping guides. Find the best products faster with spreadsheet shopping.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
            <a
              href="#categories"
              className="px-7 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
            >
              Explore Latest Spreadsheet
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3.5 bg-white/15 backdrop-blur-sm text-white font-semibold text-sm rounded-full border border-white/30 hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              VigorBuy Spreadsheet
            </a>
          </div>

          <div className="flex flex-wrap gap-3 md:gap-5">
            {[
              { icon: 'ri-checkbox-circle-line', text: 'Updated Product Database' },
              { icon: 'ri-shield-check-line', text: 'Organized Categories' },
              { icon: 'ri-image-line', text: 'QC Photo Guides' },
              { icon: 'ri-guide-line', text: 'Shopping Safety Tips' },
              { icon: 'ri-user-star-line', text: 'Beginner Friendly Guides' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-xs md:text-sm text-white/75">
                <div className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-accent-400 text-sm`}></i>
                </div>
                <span className="whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}